// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","logo":"About_logo__uulbo","text":"About_text__q-vdH"};